// Keep in sync with po-cart-item-details.liquid, which builds the same key in Liquid.
const MONOGRAM_REMOVED_ATTRIBUTE_PREFIX = '_monogram_removed_';

class CartRemoveButton extends HTMLElement {
  constructor() {
    super();
    this.handleClick = this.handleClick.bind(this);
  }

  connectedCallback() {
    this.addEventListener('click', this.handleClick);
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.handleClick);
  }

  handleClick(event) {
    event.preventDefault();
      
    const cartItems = this.closest('cart-items') || this.closest('cart-drawer-items');
    const cartItemToRemove = this.closest('.cart-item');
    const itemIndex = Array.from(cartItemToRemove.parentNode.children).indexOf(cartItemToRemove);
    const checkoutButton = document.querySelector('button#checkout');

    this.shouldShowMessage = true;
    this.messageIndex = itemIndex;
    
    const unsubscribe = subscribe(PUB_SUB_EVENTS.cartUpdate, (eventData) => {
      if (this.shouldShowMessage && eventData.source === 'cart-items') {
        this.showMessageAtIndex(this.messageIndex);
        this.shouldShowMessage = false;
        unsubscribe();

        if (checkoutButton && !checkoutButton.classList.contains('checkout-blocked')) {
          checkoutButton.removeAttribute('disabled');
        }
      }
    });

    cartItems.updateQuantity(this.dataset.index, 0, event);
  }
  
  showMessageAtIndex(index) {
    const originalMessage = document.getElementById('remove-message');
    if (!originalMessage) return;

    const message = originalMessage.cloneNode(true);
    message.classList.remove('tw-hidden');
    message.classList.add('tw-flex');

    const closeButton = message.querySelector('.remove-message__close');
    closeButton?.addEventListener('click', () => message.remove());

    setTimeout(() => {
      message.remove();
    }, 3000);

    const itemList = document.querySelector('.po-cart-items__available');
    if (itemList) {
      const children = itemList.children;
      if (index < children.length) {
        itemList.insertBefore(message, children[index]);
      } else {
        itemList.insertBefore(message, children[index - 1]);
      }
    } else {
      const emptyCart = document.querySelector('.po-main-cart-items--snippet .cart__warnings');
      if(!emptyCart) return;
      
      message.classList.add('tw-mt-po-spacings-base');
      emptyCart.insertAdjacentElement('afterend', message);
    }
  }
}

customElements.define('cart-remove-button', CartRemoveButton);

class CartItems extends HTMLElement {
  constructor() {
    super();
    this.lineItemStatusElement =
      document.getElementById('shopping-cart-line-item-status') || document.getElementById('CartDrawer-LineItemStatus');

    const debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, ON_CHANGE_DEBOUNCE_TIMER);

    this.addEventListener('change', debouncedOnChange.bind(this));
  }

  cartUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      if (event.source === 'cart-items' || event.source === 'po-cart-promo-code') {
        return;
      }
      return this.onCartUpdate();
    });
  }

  disconnectedCallback() {
    if (this.cartUpdateUnsubscriber) {
      this.cartUpdateUnsubscriber();
    }
  }

  resetQuantityInput(id) {
    const input = this.querySelector(`#Quantity-${id}`);
    input.value = input.getAttribute('value');
    this.isEnterPressed = false;
  }

  setValidity(event, index, message) {
    event.target.setCustomValidity(message);
    event.target.reportValidity();
    this.resetQuantityInput(index);
    event.target.select();
  }

  validateQuantity(event) {
    const inputValue = parseInt(event.target.value);
    const index = event.target.dataset.index;
    let message = '';

    if (inputValue < event.target.dataset.min) {
      message = window.quickOrderListStrings.min_error.replace('[min]', event.target.dataset.min);
    } else if (inputValue > parseInt(event.target.max)) {
      message = window.quickOrderListStrings.max_error.replace('[max]', event.target.max);
    } else if (inputValue % parseInt(event.target.step) !== 0) {
      message = window.quickOrderListStrings.step_error.replace('[step]', event.target.step);
    }

    if (message) {
      this.setValidity(event, index, message);
    } else {
      event.target.setCustomValidity('');
      event.target.reportValidity();
      this.updateQuantity(
        index,
        inputValue,
        event,
        document.activeElement.getAttribute('name'),
        event.target.dataset.quantityVariantId
      );
    }
  }

  onChange(event) {
    this.validateQuantity(event);
  }

  onCartUpdate() {
    if (this.tagName === 'CART-DRAWER-ITEMS') {
      return fetch(`${routes.cart_url}?section_id=cart-drawer`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const selectors = ['cart-drawer-items', '.cart-drawer__footer'];
          for (const selector of selectors) {
            const targetElement = document.querySelector(selector);
            const sourceElement = html.querySelector(selector);
            if (targetElement && sourceElement) {
              targetElement.replaceWith(sourceElement);
            }
          }
        })
        .catch((e) => {
          console.error(e);
        });
    } else {
      const mainCartItems = document.getElementById('main-cart-items');
      const isPoCart = Boolean(this.querySelector('.po-main-cart-items--snippet') || document.querySelector('.po-main-cart-items--snippet'));
      const sectionId = mainCartItems?.dataset?.id;
      const fetchSectionId = isPoCart && sectionId ? sectionId : 'main-cart-items';

      return fetch(`${routes.cart_url}?section_id=${fetchSectionId}`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');

          if (isPoCart) {
            const sourceItems = html.querySelector('.js-contents-items');
            const targetItems = this.querySelector('.js-contents-items') || document.querySelector('.js-contents-items');
            if (sourceItems && targetItems) {
              targetItems.innerHTML = sourceItems.innerHTML;
            }
            return;
          }

          const sourceQty = html.querySelector('cart-items');
          if (sourceQty) this.innerHTML = sourceQty.innerHTML;
        })
        .catch((e) => {
          console.error(e);
        });
    }
  }

  getSectionsToRender() {
    return [
      {
        id: 'main-cart-items',
        section: document.getElementById('main-cart-items').dataset.id,
        selector: '.js-contents-items',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
      {
        id: 'cart-live-region-text',
        section: 'cart-live-region-text',
        selector: '.shopify-section',
      },
      {
        id: 'main-cart-footer',
        section: document.getElementById('main-cart-footer').dataset.id,
        selector: '.js-contents-footer',
      },
       {
        id: 'main-cart-editorial',
        section: document.getElementById('main-cart-editorial').dataset.id,
        selector: '.js-contents-editorial',
      },
    ];
  }

  updateQuantity(line, quantity, event, name, variantId) {
    this.enableLoading(line);

    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname,
    });
    const eventTarget = event.currentTarget instanceof CartRemoveButton ? 'clear' : 'change';

    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);

        CartPerformance.measure(`${eventTarget}:paint-updated-sections"`, () => {
          const quantityElement =
            document.getElementById(`Quantity-${line}`) || document.getElementById(`Drawer-quantity-${line}`);
          const items = document.querySelectorAll('.cart-item');

          if (parsedState.errors) {
            quantityElement.value = quantityElement.getAttribute('value');
            this.updateLiveRegions(line, parsedState.errors);
            return;
          }

          // Remove prescription attributes if corresponding items are no longer in the cart
          this.removePrescriptionAttributes(parsedState);

          this.classList.toggle('is-empty', parsedState.item_count === 0);
          const cartDrawerWrapper = document.querySelector('cart-drawer');
          document.querySelectorAll('.main-cart-footer').forEach((element) => {
            element.classList.toggle('is-empty', parsedState.item_count === 0);
          });
          if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', parsedState.item_count === 0);

          this.getSectionsToRender().forEach((section) => {
            const elementToReplace =
              document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
            elementToReplace.innerHTML = this.getSectionInnerHTML(
              parsedState.sections[section.section],
              section.selector
            );
          });
          const updatedValue = parsedState.items[line - 1] ? parsedState.items[line - 1].quantity : undefined;
          let message = '';
          if (items.length === parsedState.items.length && updatedValue !== parseInt(quantityElement.value)) {
            if (typeof updatedValue === 'undefined') {
              message = window.cartStrings.error;
            } else {
              message = window.cartStrings.quantityError.replace('[quantity]', updatedValue);
            }
          }
          this.updateLiveRegions(line, message);

          const lineItem =
            document.getElementById(`CartItem-${line}`) || document.getElementById(`CartDrawer-Item-${line}`);
          if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
            cartDrawerWrapper
              ? trapFocus(cartDrawerWrapper, lineItem.querySelector(`[name="${name}"]`))
              : lineItem.querySelector(`[name="${name}"]`).focus();
          } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
            trapFocus(cartDrawerWrapper.querySelector('.drawer__inner-empty'), cartDrawerWrapper.querySelector('a'));
          } else if (document.querySelector('.cart-item') && cartDrawerWrapper) {
            trapFocus(cartDrawerWrapper, document.querySelector('.cart-item__name'));
          }
        });

        CartPerformance.measureFromEvent(`${eventTarget}:user-action`, event);

        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items', cartData: parsedState, variantId: variantId });
      })
      .catch(() => {
        this.querySelectorAll('.loading__spinner').forEach((overlay) => overlay.classList.add('hidden'));
        const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
        errors.textContent = window.cartStrings.error;
      })
      .finally(() => {
        this.disableLoading(line);
      });
  }

  updateSections (sections) {
    this.getSectionsToRender().forEach((section) => {
      const sectionHTML = sections[section.section];
      let elementToReplace = document.getElementById(section.id);
      elementToReplace = elementToReplace?.querySelector(section.selector) || elementToReplace;

      if (sectionHTML && elementToReplace) {
        const inner = this.getSectionInnerHTML(sectionHTML, section.selector);
        if (inner !== null) elementToReplace.innerHTML = inner;
      }

    });
  }

  updateLiveRegions(line, message) {
    const lineItemError =
      document.getElementById(`Line-item-error-${line}`) || document.getElementById(`CartDrawer-LineItemError-${line}`);
    if (lineItemError) lineItemError.querySelector('.cart-item__error-text').textContent = message;

    this.lineItemStatusElement.setAttribute('aria-hidden', true);

    const cartStatus =
      document.getElementById('cart-live-region-text') || document.getElementById('CartDrawer-LiveRegionText');
    cartStatus.setAttribute('aria-hidden', false);

    setTimeout(() => {
      cartStatus.setAttribute('aria-hidden', true);
    }, 1000);
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  enableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.add('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading__spinner`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading__spinner`);

    [...cartItemElements, ...cartDrawerItemElements].forEach((overlay) => overlay.classList.remove('hidden'));

    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute('aria-hidden', false);
  }

  disableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.remove('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading__spinner`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading__spinner`);

    cartItemElements.forEach((overlay) => overlay.classList.add('hidden'));
    cartDrawerItemElements.forEach((overlay) => overlay.classList.add('hidden'));
  }

  // Remove prescription attributes if corresponding items are no longer in the cart
  removePrescriptionAttributes (cartData) {
    const cartAttributes = cartData?.attributes || {};
    const newAttributes = {};

    for (const key in cartAttributes) {
      const isPrescription = key.startsWith("prescription_");
      const isMonogramRemoved = key.startsWith(MONOGRAM_REMOVED_ATTRIBUTE_PREFIX);

      if (!isPrescription && !isMonogramRemoved) continue;

      if (!cartData.items || cartData.items.length === 0) {
        newAttributes[key] = "";
        continue;
      }

      try {
        const attribute = JSON.parse(cartAttributes[key]);

        if (isMonogramRemoved) {
          const productId = key.slice(MONOGRAM_REMOVED_ATTRIBUTE_PREFIX.length);
          const frameGone = !cartData.items.some(item => String(item.product_id) === productId);
          // The user backed out of the RXC flow, so the monogram survived and the notice is moot.
          const monogramStillThere = cartData.items.some(
            item => item.properties?.monogram_parent_id === attribute.frameVariantId
          );

          if (frameGone || monogramStillThere) {
            newAttributes[key] = "";
          }
          continue;
        }

        const irid = attribute["_itemsRelationshipId"];

        if (irid && !cartData.items.some(item => item.properties["_itemsRelationshipId"] === irid)) {
          newAttributes[key] = "";
        }
      }
      catch (e) {
        console.error(`Error parsing attribute ${key}:`, e);
      }
    }

    if (Object.keys(newAttributes).length === 0) return;

    const body = JSON.stringify({
      attributes: newAttributes,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.routes?.cart_url,
    });

    fetch(routes.cart_update_url, { ...fetchConfig(), ...{ body } })
      .then((response) => response.json())
      .then((state) => {
        console.log("Attributes updated:", state.attributes);
        state.sections ? this.updateSections(state.sections) : window.location.reload();
      })
      .catch((error) => console.error('Error removing prescription attributes:', error));

  }
}

customElements.define('cart-items', CartItems);

if (!customElements.get('cart-note')) {
  customElements.define(
    'cart-note',
    class CartNote extends HTMLElement {
      constructor() {
        super();

        this.addEventListener(
          'input',
          debounce((event) => {
            const body = JSON.stringify({ note: event.target.value });
            fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } })
              .then(() => CartPerformance.measureFromEvent('note-update:user-action', event));
          }, ON_CHANGE_DEBOUNCE_TIMER)
        );
      }
    }
  );
}

class PhiConsent extends HTMLElement {
  constructor() {
    super();

    this.handleChange = this.handleChange.bind(this);
    this.handleScrollButton = this.handleScrollButton.bind(this);
    this.handleCheckoutAttempt = this.handleCheckoutAttempt.bind(this);
    this.updateExpressCheckoutVisibility = this.updateExpressCheckoutVisibility.bind(this);
  }

  connectedCallback() {
    this.checkbox = this.querySelector('#cart-phi-checkbox');
    this.checkboxScrollButton = document.querySelector('[data-phi-consent-scroll-button], button#phi-button-scroll');
    this.checkoutButton = document.querySelector('button#checkout');
    this.cartForm = this.checkoutButton?.form || document.getElementById('cart');
    this.expressCheckoutElements = document.querySelectorAll('[data-phi-consent-express-checkout]');

    if (this.checkoutButton) {
      if (this.checkbox) {
        this.checkbox.addEventListener('change', this.handleChange);
        this.checkoutButton.addEventListener('click', this.handleCheckoutAttempt, true);
        this.cartForm?.addEventListener('submit', this.handleCheckoutAttempt, true);
        this.updateCheckoutAvailability();
      }
      
      if (this.checkboxScrollButton && this.checkbox) {
        this.checkboxScrollButton.addEventListener('click', this.handleScrollButton);
      }
    }
  }

  disconnectedCallback() {
    if (this.checkbox) {
      this.checkbox.removeEventListener('change', this.handleChange);
    }

    if (this.checkboxScrollButton) {
      this.checkboxScrollButton.removeEventListener('click', this.handleScrollButton);
    }

    if (this.checkoutButton) {
      this.checkoutButton.removeEventListener('click', this.handleCheckoutAttempt, true);
    }

    if (this.cartForm) {
      this.cartForm.removeEventListener('submit', this.handleCheckoutAttempt, true);
    }
  }

  updateExpressCheckoutVisibility() {
    const shouldHideExpressCheckout = !this.checkbox?.checked;

    this.expressCheckoutElements?.forEach((element) => {
      element.setAttribute('data-phi-consent-hidden', shouldHideExpressCheckout ? 'true' : 'false');

      if (shouldHideExpressCheckout) {
        element.setAttribute('aria-hidden', 'true');
      } else {
        element.removeAttribute('aria-hidden');
      }
    });
  }

  updateCheckoutAvailability() {
    // The checkout could be blocked for other reasons, 
    // so if there is 'checkout-blocked' class I do not remove the disable.
    if (!this.checkoutButton.classList.contains('checkout-blocked')) {
      if (!this.checkbox?.checked) {
        this.checkoutButton.setAttribute('disabled', 'disabled');
        this.checkoutButton.setAttribute('aria-disabled', 'true');
      } else {
        this.checkoutButton.removeAttribute('disabled');
        this.checkoutButton.removeAttribute('aria-disabled');
      }
    }

    this.updateExpressCheckoutVisibility();
  }

  handleChange() {
    this.updateCheckoutAvailability();
  }

  handleCheckoutAttempt(event) {
    if (this.checkbox?.checked) return;

    event?.preventDefault();
    event?.stopImmediatePropagation?.();
    event?.stopPropagation?.();
    this.updateCheckoutAvailability();
    this.scrollToCheckbox();
  }

  scrollToCheckbox() {
    this.checkbox?.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }

  handleScrollButton(event) {
    event?.preventDefault();

    if (!this.checkbox?.checked) {
      event?.stopImmediatePropagation?.();
      event?.stopPropagation?.();
      this.updateCheckoutAvailability();
      this.scrollToCheckbox();
    } else {
      this.checkoutButton?.click();
    }
  }
}

customElements.define('phi-consent', PhiConsent);
